





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { IUser } from '@/interfaces/user';
import { IGroup } from '../../interfaces/group';
import CreateGroupMutation from '@/graphql/mutations/createGroup.gql';
import request from '@/graphql/request';

@Component({
  components: {
  },
})
export default class GroupAddGroup extends Vue {
  @Prop({ required: true })
  public group!: IGroup;

  public name: string = '';

  

  public async createGroup() {
    const { data, errors } = await request(CreateGroupMutation, {
      name: this.name,
      parentId: this.group.id,
    });

    if (!errors || !errors.length) {
      this.$router.push(`/group/${data.id}`);
    }
  }
}
